module.exports = __webpack_public_path__ + "img/html.07b7972b.svg";